import React, { useState, useEffect } from "react";
import { TextField, IconButton, Avatar, Typography } from "@mui/material";
import { Send as SendIcon } from "@mui/icons-material";

const ChatScreen = () => {
  const [messages, setMessages] = useState([
    { sender: "vendor", message: "Hello! How can I assist you today?" },
    { sender: "customer", message: "I need help with my shipment." },
  ]);
  const [newMessage, setNewMessage] = useState("");
  const [typing, setTyping] = useState(false);

  const handleSendMessage = () => {
    if (newMessage.trim() !== "") {
      setMessages([...messages, { sender: "customer", message: newMessage }]);
      setNewMessage(""); // Clear input
    }
  };

  const handleTyping = (e) => {
    setNewMessage(e.target.value);
    setTyping(e.target.value.length > 0);
  };

  useEffect(() => {
    if (typing) {
      const timer = setTimeout(() => {
        setTyping(false); // Stop typing after a short delay
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [typing]);

  return (
    <div className="flex flex-col h-screen bg-dark p-4">
      {/* Header Section */}
      <div className="flex items-center justify-between  p-4 rounded-lg shadow-md mb-4 position-fixed">
        <div className="flex items-center space-x-3">
          <Avatar alt="Vendor" src="/vendor-avatar.jpg" sx={{ width: 40, height: 40 }} />
          <div className="flex flex-col">
            <Typography variant="h6" className="text-lg font-semibold">
              Vendor Support
            </Typography>
            <Typography variant="body2" className="text-sm text-blue-500">
              Online
            </Typography>
          </div>
        </div>
      </div>

      {/* Chat Messages Section */}
      <div className="flex-1 overflow-y-auto mb-4 p-4 rounded-lg shadow-md space-y-4">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`flex ${msg.sender === "customer" ? "justify-end" : "justify-start"}`}
          >
            <div className="flex items-start space-x-2">
              {msg.sender === "vendor" && (
                <Avatar alt="Vendor" src="/vendor-avatar.jpg" sx={{ width: 30, height: 30 }} />
              )}
              <div
                className={`max-w-xs p-4 rounded-lg ${
                  msg.sender === "customer"
                    ? "bg-blue-500 text-white"
                    : "bg-blue-500 text-white"
                }`}
              >
                {msg.message}
              </div>
              {/* {msg.sender === "customer" && (
                <Avatar alt="Customer" src="/customer-avatar.jpg" sx={{ width: 30, height: 30 }} />
              )} */}
            </div>
          </div>
        ))}
        {typing && (
          <div className="flex justify-start space-x-2">
            <Avatar alt="Vendor" src="/vendor-avatar.jpg" sx={{ width: 30, height: 30 }} />
            <div className="text-gray-500">Vendor is typing...</div>
          </div>
        )}
      </div>

      {/* Input Section */}
      <div className="flex items-center bg-white p-3 rounded-lg shadow-md">
        <TextField
          variant="outlined"
          fullWidth
          value={newMessage}
          onChange={handleTyping}
          placeholder="Type a message..."
          size="small"
          className="mr-2"
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              borderRadius: "20px",
            },
            "& .MuiInputBase-input": {
              padding: "12px 16px",
              fontSize: "14px",
              color: "#4A4A4A",
            },
          }}
        />
        <IconButton
          color="primary"
          onClick={handleSendMessage}
          sx={{
            backgroundColor: "#0D6EFD",
            "&:hover": { backgroundColor: "#0056b3" },
            borderRadius: "50%",
          }}
        >
          <SendIcon sx={{ color: "white" }} />
        </IconButton>
      </div>
    </div>
  );
};

export default ChatScreen;
